import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button, Card, Money } from '../components/ui';

const OPERATOR_METHODS: Record<string, string> = {
  blik: 'BLIK',
  card: 'Karta płatnicza',
  transfer: 'Szybki przelew',
};

/**
 * Symulacja strony operatora płatności.
 *
 * Świadomie wygląda i zachowuje się inaczej niż sklep: własna kolorystyka,
 * brak nawigacji sklepu, powrót przez pełne przeładowanie strony.
 */
export function Payment() {
  const [sp] = useSearchParams();
  const orderId = sp.get('zamowienie') ?? '';
  const amount = Number(sp.get('kwota') ?? 0);
  const method = OPERATOR_METHODS[sp.get('metoda') ?? ''] ?? 'Płatność online';
  const [busy, setBusy] = useState(false);

  // Operator płatności ma własny tytuł strony — to nie jest podstrona sklepu.
  useEffect(() => {
    document.title = 'PayNordic — bezpieczna płatność';
  }, []);

  const finish = (ok: boolean) => {
    setBusy(true);
    setTimeout(() => {
      window.location.href = ok
        ? `/potwierdzenie/${orderId}`
        : `/zamowienie?blad=platnosc&zamowienie=${orderId}`;
    }, 1200);
  };

  return (
    <div className="fixed inset-0 z-50 overflow-auto bg-[#f4f6fb] p-4 text-slate-800">
      <div className="mx-auto mt-10 max-w-md">
        <div className="mb-4 flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded bg-[#1c3faa] text-sm font-bold text-white">
            P
          </span>
          <span className="font-semibold text-[#1c3faa]">PayNordic</span>
          <span className="ml-auto text-[11px] text-slate-500">🔒 połączenie szyfrowane</span>
        </div>

        <Card className="border-slate-200 bg-white p-6 shadow-sm">
          <h1 className="text-lg font-semibold text-slate-900">Podsumowanie płatności</h1>
          <dl className="mt-4 space-y-2 text-[13px]">
            <div className="flex justify-between border-b border-slate-100 pb-2">
              <dt className="text-slate-500">Sprzedawca</dt>
              <dd className="font-medium">Nordform</dd>
            </div>
            <div className="flex justify-between border-b border-slate-100 pb-2">
              <dt className="text-slate-500">Numer zamówienia</dt>
              <dd className="font-mono">{orderId}</dd>
            </div>
            <div className="flex justify-between border-b border-slate-100 pb-2">
              <dt className="text-slate-500">Metoda</dt>
              <dd className="font-medium">{method}</dd>
            </div>
            <div className="flex justify-between pt-1">
              <dt className="text-slate-500">Kwota</dt>
              <dd className="text-lg font-semibold text-slate-900">
                <Money v={amount} />
              </dd>
            </div>
          </dl>

          <div className="mt-6 space-y-2">
            <Button className="w-full bg-[#1c3faa] py-2.5 hover:bg-[#173488]" disabled={busy} onClick={() => finish(true)}>
              {busy ? 'Przetwarzam płatność…' : 'Zapłać i wróć do sklepu'}
            </Button>
            <button
              disabled={busy}
              onClick={() => finish(false)}
              className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-600 hover:bg-slate-50 disabled:opacity-40"
            >
              Anuluj płatność
            </button>
          </div>

          <p className="mt-4 text-[11px] leading-relaxed text-slate-400">
            Strona demonstracyjna. Żadna płatność nie zostanie pobrana.
          </p>
        </Card>
      </div>
    </div>
  );
}
